import { render, staticRenderFns } from "./VehicleSourcePriceInformationField.vue?vue&type=template&id=cdf988f2&scoped=true"
import script from "./VehicleSourcePriceInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourcePriceInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourcePriceInformationField.vue?vue&type=style&index=0&id=cdf988f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf988f2",
  null
  
)

export default component.exports